import axiosInstance from "../../../../axiosInstance";
import NProgress from 'nprogress';
import { BASE_URL, HRMS_ATS_API_URL } from "../../../Constants/baseConstant";
import { ConvertDateTime, getAtsUserId, getDomain, getImageSignedUrl, getUserData } from "../../Base/helper/baseFunctions";
import { toast } from 'react-toastify';
import { AtsEmailHelper } from "./ATSEmailHeper";
import { renderEmail } from "react-html-email";
import { BaseEmailTemplate2 } from "../../Base/views/BaseEmailTemplate";
import {
  MprCreatedEmailContent,
  MprApprovalPendingEmailContent,
  MprRejectedEmailContent,
  MprFinalApprovedEmailContent,
  getMprCreatedSubject,
  getMprApprovalPendingSubject,
  getMprRejectedSubject,
  getMprFinalApprovedSubject
} from "./AtsMprMailContentHelper";
import { generateMprDocAttachment } from "./AtsMprDocDownloadHelper";

// Hiring Request > Request Tab
export const fnGetMprRequestsHelper = async (params) => {
    NProgress.start()
    return await axiosInstance(`/ats/getMprRequests`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
        .then((res) => {
            NProgress.done()
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done()
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const fnUpsertMprRequestsHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...")
    const userdata = getUserData();
    return await axiosInstance(`/ats/upsertMprRequests`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            user_id: userdata?.ats_user_id,
            mpr_request_fk: params?.mpr_request_fk || null,
            status: params?.status,
            role: params?.role,
            bu_fk: params?.bu_fk,
            location: params?.location,
            headcount: params?.headcount,
            min_budget: null,
            max_budget: params?.max_budget || null,
            approver_employee_id: params?.approver_employee_id,
            justification_comment: params?.justification_comment,
            hiring_type: params?.hiring_type,
            is_budgeted: params?.is_budgeted,
            target_date: params?.target_date,
            second_approver_employee_id: params?.second_approver_employee_id,
            third_approver_employee_id: params?.third_approver_employee_id,
            jd: params?.jd || "",
            mpr_metadata_json: params?.mpr_metadata_json || "",
            min_salary: params?.min_salary || null,
            max_salary: params?.max_salary || null,
            grade: params?.grade || "",
            additional_comments: params?.additional_comments || "",
            min_experience: params?.min_experience || null,
            max_experience: params?.max_experience || null,
            employmenttype_fk: params?.employmenttype_fk || null,
            replacement_details: params?.replacement_details || null,
            sub_role: params?.sub_role || "",
            hr_leads: params?.hr_leads || ""
         }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("MPR Request saved successfully")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to save MPR Request")
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}
// Hiring Request > Approval Tab
export const fnGetApproverMprRequestsHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/getApproverMprRequests`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            login_employee_id: getAtsUserId(),
            all_status: params?.all_status || false,
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};

export const fnUpdateApproverMprRequestsHelper = async (params) => {
    toast.dismiss();
    toast.info("Updating...");
    const userdata = getUserData();
    return await axiosInstance(`/ats/updateApproverMprRequests`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            login_employee_id: getAtsUserId(),
            mpr_request_fk: params?.mpr_request_fk,
            status: params?.status,
            user_id: userdata?.ats_user_id,
            approved_positions_count: params?.approved_positions_count || null,
            mpr_metadata_json: params?.mpr_metadata_json,
            approver_target_offer_release_date: params?.approver_target_offer_release_date || null,
            approver_grade: params?.approver_grade || "",
            approver_notice_period: params?.approver_notice_period || null,
            approver_min_salary: params?.approver_min_salary || null,
            approver_max_salary: params?.approver_max_salary || null,
            approved_budget: params?.approved_budget || null,
            replacement_details: params?.replacement_details || null
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("MPR Request updated successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to update MPR Request");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};

export const fnGetJobMprHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/getJobMpr`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            ats_jobpost_fk: params?.ats_jobpost_fk,
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};

export const fnDeleteJobMprHelper = async (params) => {
    toast.dismiss();
    return await axiosInstance(`/ats/deleteJobMpr`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            ats_jobpost_mpr_mapping_pk: params?.ats_jobpost_mpr_mapping_pk,
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to delete Job MPR mapping");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};

export const fnAddJobMprHelper = async (params) => {
    toast.dismiss();
    const userdata = getUserData();
    return await axiosInstance(`/ats/addJobMpr`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            mpr_requests_fk: params?.mpr_requests_fk || null,
            ats_jobpost_fk: params?.ats_jobpost_fk,
            user_id: userdata?.ats_user_id,
            primary_approver_id: params?.primary_approver_id || null,
            secondary_approver_id: params?.secondary_approver_id || null,
        }
    })
        .then((res) => {
            toast.dismiss();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Failed to add Job MPR mapping");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};


export const fnGetMprDashboardHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/getMprDashboard`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};

export const fnGetAvailableJobMprHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/getAvailableJobMpr`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
            ats_jobpost_fk: params?.ats_jobpost_fk,
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};

export const fnGetMprDashboardCardsHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/getMprDashboardCards`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};

export const GetMprApproverListHelper = async (params) => {
    NProgress.start();
    return await axiosInstance(`/ats/getMprApproverList`, {
        method: "POST",
        baseURL: HRMS_ATS_API_URL,
        data: {
            domain_name: getDomain(),
        }
    })
        .then((res) => {
            NProgress.done();
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            NProgress.done();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
};

export const sendApprovalMailNotificationHelper = async (params) => {
  try {
    if (!params?.to) {
      console.warn("sendApprovalMailNotificationHelper: Recipient email is missing. Notification skipped.");
      return { message: "Recipient email is missing", hasError: true };
    }

    let company_logo = null;
    if (params?.companyLogo) {
      try {
        company_logo = await getImageSignedUrl(params?.companyLogo);
      } catch (e) {
        console.warn("sendApprovalMailNotificationHelper: Failed to get signed company logo url", e);
      }
    }

    const emailContent =
      typeof params?.content === "string"
        ? params?.content
        : renderEmail(
            <BaseEmailTemplate2 company_logo={company_logo}>
              {params?.content}
            </BaseEmailTemplate2>
          );

    return await AtsEmailHelper({
      to: params?.to,
      cc: params?.cc,
      bcc: params?.bcc,
      subject: params?.subject || "Manpower Requisition Notification",
      content: emailContent,
      attachments: params?.attachments || false,
      NotShow: params?.NotShow !== undefined ? params?.NotShow : true,
    });
  } catch (error) {
    console.error("sendApprovalMailNotificationHelper error:", error);
    return { message: "Failed to send email", hasError: true, error };
  }
};

export const parseEmails = (input) => {
  if (!input) return [];
  if (Array.isArray(input)) {
    return input.flatMap((item) => {
      if (typeof item === "string") return parseEmails(item);
      if (item && typeof item === "object") {
        return parseEmails(item.email || item.email_id || item.id || item.value || "");
      }
      return [];
    });
  }
  if (typeof input === "string") {
    const trimmed = input.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
      try {
        const parsed = JSON.parse(trimmed);
        return parseEmails(parsed);
      } catch (e) {
        // Fall back to splitting
      }
    }
    return trimmed
      .split(/[,;\n]+/)
      .map((e) => e.trim().replace(/^['"<]+|['">]+$/g, ""))
      .filter((e) => e && e.includes("@"));
  }
  return [];
};

export const buildCcEmails = (recipientTo, ...sources) => {
  const toLower = (recipientTo || "").trim().toLowerCase();
  const seen = new Set();
  const result = [];
  sources?.forEach((source) => {
    parseEmails(source)?.forEach((email) => {
      const trimmed = (email || "").trim();
      const lower = trimmed.toLowerCase();
      if (lower && lower !== toLower && !seen.has(lower)) {
        seen.add(lower);
        result.push(trimmed);
      }
    });
  });
  return result.length > 0 ? result.join(",") : undefined;
};

export const triggerMprEmailNotificationHelper = async ({
  scenario, // "CREATED" | "FIRST_APPROVER_APPROVED" | "SECOND_APPROVER_APPROVED" | "REJECTED" | "FINAL_APPROVED"
  record,
  approverLevel = "first-level",
  rejectedByName,
  finalApproverName,
  remarks = "",
  companyLogo,
  appLink = BASE_URL,
  attachments: customAttachments,
  attachDoc = true,
  isReminder = false,
}) => {
  if (!record) {
    console.warn("triggerMprEmailNotificationHelper: No record provided");
    return;
  }

  const creatorName = record?.mpr_owner_name;
  const creatorEmail = record?.mpr_owner_email ;

  const firstApproverName = record?.approver_name;
  const firstApproverEmail = record?.approver_email;

  const secondApproverName = record?.second_approver_emp_name;
  const secondApproverEmail = record?.second_approver_email;

  const thirdApproverName = record?.third_approver_emp_name;
  const thirdApproverEmail = record?.third_approver_email;
  const hrLeadsList = record?.hr_leads || "";

  let to = "";
  let cc = undefined;
  let subject = "";
  let content = null;

  switch (scenario) {
    case "CREATED":
      // Scenario 1: New MPR Created — Notify First Approver, Creator & Other Approvers & HR Leads in CC
      to = firstApproverEmail;
      cc = buildCcEmails(to, creatorEmail, hrLeadsList);
      subject = getMprCreatedSubject(record?.mpr_no, record?.role);
      content = (
        <MprCreatedEmailContent
          approverName={firstApproverName}
          creatorName={creatorName}
          mprNo={record?.mpr_no}
          role={record?.role}
          subRole={record?.sub_role}
          buName={record?.bu_name}
          headcount={record?.headcount}
          hiringType={record?.hiring_type}
          createdOn={ConvertDateTime(record?.createdon || new Date().toISOString())}
          appLink={appLink}
          isReminder={isReminder}
        />
      );
      break;

    case "FIRST_APPROVER_APPROVED":
      // Scenario 3: First Approver Approves — Notify Second Approver, Creator & Other Approvers & HR Leads in CC
      to = secondApproverEmail;
      cc = buildCcEmails(to, creatorEmail, hrLeadsList);
      subject = getMprApprovalPendingSubject(record?.mpr_no, record?.role, 2);
      content = (
        <MprApprovalPendingEmailContent
          approverName={secondApproverName}
          mprNo={record?.mpr_no}
          role={record?.role}
          subRole={record?.sub_role}
          buName={record?.bu_name}
          headcount={record?.headcount}
          level={2}
          previousApproverName={firstApproverName}
          currentStatus="Awaiting Second-Level Approval"
          appLink={appLink}
          isReminder={isReminder}
        />
      );
      break;

    case "SECOND_APPROVER_APPROVED":
      // Scenario 5: Second Approver Approves — Notify Third Approver, Creator & Other Approvers & HR Leads in CC
      to = thirdApproverEmail;
      cc = buildCcEmails(to, creatorEmail, hrLeadsList);
      subject = getMprApprovalPendingSubject(record?.mpr_no, record?.role, 3);
      content = (
        <MprApprovalPendingEmailContent
          approverName={thirdApproverName}
          mprNo={record?.mpr_no}
          role={record?.role}
          subRole={record?.sub_role}
          buName={record?.bu_name}
          headcount={record?.headcount}
          level={3}
          previousApproverName={firstApproverName}
          secondApproverName={secondApproverName}
          currentStatus="Awaiting Third-Level Approval"
          appLink={appLink}
          isReminder={isReminder}
        />
      );
      break;

    case "REJECTED":
      // Scenario 2, 4, 6: Rejection — Notify Creator, Approvers & HR Leads in CC
      to = creatorEmail;
      cc = buildCcEmails(to, hrLeadsList);
      subject = getMprRejectedSubject(record?.mpr_no, record?.role);
      content = (
        <MprRejectedEmailContent
          creatorName={creatorName}
          mprNo={record?.mpr_no}
          role={record?.role}
          subRole={record?.sub_role}
          buName={record?.bu_name}
          rejectedByName={rejectedByName}
          approverLevel={approverLevel}
          comments={remarks}
          rejectionDate={ConvertDateTime(new Date().toISOString())}
          appLink={appLink}
        />
      );
      break;

    case "FINAL_APPROVED":
      // Scenario 7: All levels approved / Final Approval — Notify Creator, Approvers & HR Leads in CC
      to = creatorEmail;
      cc = buildCcEmails(to, hrLeadsList);
      subject = getMprFinalApprovedSubject(record?.mpr_no, record?.role);
      content = (
        <MprFinalApprovedEmailContent
          creatorName={creatorName}
          mprNo={record?.mpr_no}
          role={record?.role}
          subRole={record?.sub_role}
          buName={record?.bu_name}
          headcount={record?.headcount}
          finalApproverName={finalApproverName || firstApproverName}
          approvalDate={ConvertDateTime(new Date().toISOString())}
          appLink={appLink}
        />
      );
      break;

    default:
      console.warn("triggerMprEmailNotificationHelper: Unknown scenario:", scenario);
      return;
  }
  if (isReminder && subject && !subject.startsWith("[Reminder]")) {
    subject = `[Reminder] ${subject}`;
  }

  if (!to) {
    console.warn(`triggerMprEmailNotificationHelper: Recipient email address missing for scenario ${scenario}. Notification not sent.`);
    return;
  }

  let attachments = customAttachments || false;
  if (!attachments && attachDoc && record) {
    try {
      const docAttachment = await generateMprDocAttachment(record);
      if (docAttachment) {
        attachments = [docAttachment];
      }
    } catch (docErr) {
      console.warn("triggerMprEmailNotificationHelper: Failed to generate MPR doc attachment:", docErr);
    }
  }

  return await sendApprovalMailNotificationHelper({
    to,
    cc,
    subject,
    content,
    companyLogo,
    attachments,
    NotShow: true,
  });
};

/**
 * Returns pending approver details based on current MPR status:
 * - "Submitted" -> First Approver | "Awaiting Second Approval" -> Second Approver | "Awaiting Third Approval" -> Third Approver
 */
export const getMprPendingApproverInfo = (record) => {
  if (!record) return null;
  const status = (record?.mpr_status || "").trim();
  const statusLower = status.toLowerCase();

  if (statusLower === "submitted") {
    return {
      level: 1,
      scenario: "CREATED",
      name: record?.approver_name,
      email: record?.approver_email,
      label: "First Approver",
    };
  }
  if (statusLower === "awaiting second approval") {
    return {
      level: 2,
      scenario: "FIRST_APPROVER_APPROVED",
      name: record?.second_approver_emp_name,
      email: record?.second_approver_email,
      label: "Second Approver",
    };
  }
  if (statusLower === "awaiting third approval") {
    return {
      level: 3,
      scenario: "SECOND_APPROVER_APPROVED",
      name: record?.third_approver_emp_name,
      email: record?.third_approver_email,
      label: "Third Approver",
    };
  }
  return null;
};

/**
 * Sends a reminder email notification to the approver currently responsible
 * for the MPR request based on its current mpr_status.
 */
export const triggerMprReminderEmailHelper = async ({ record, companyLogo }) => {
  if (!record) {
    toast.error("No MPR record found");
    return { hasError: true, message: "No record" };
  }

  const approverInfo = getMprPendingApproverInfo(record);
  if (!approverInfo) {
    toast.info(`No pending approver to remind for status "${record?.mpr_status || "Unknown"}"`);
    return { hasError: true, message: "No pending approver" };
  }

  if (!approverInfo.email) {
    toast.error(`Approver email address not found for ${approverInfo?.name}`);
    return { hasError: true, message: "Recipient email missing" };
  }

  toast.info(`Sending reminder to ${approverInfo?.name}...`);

  const res = await triggerMprEmailNotificationHelper({
    scenario: approverInfo?.scenario,
    record,
    companyLogo,
    isReminder: true,
  });

  if (res && !res.hasError) {
    toast.dismiss();
    toast.success(`Reminder sent to ${approverInfo?.name} successfully`);
    return res;
  } else {
    toast.dismiss();
    toast.error(res?.message || `Failed to send reminder to ${approverInfo?.name}`);
    return res;
  }
};